import React, { useCallback, useState } from "react";
import { ConfirmDialog } from "@activecollab/components";
import PropTypes from "prop-types";

export const ConfirmLink = ({
  children,
  title,
  description,
  confirmLabel,
  cancelLabel,
  isWarning,
  onClick,
  ...rest
}) => {
  const [confirm, setConfirm] = useState(false);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    setConfirm(true);
  }, []);

  const handleCancel = useCallback(() => {
    setConfirm(false);
  }, []);

  const handleConfirm = useCallback(() => {
    setConfirm(false);
    typeof onClick === "function" && onClick();
  }, [onClick]);

  return (
    <>
      <a
        {...rest}
        onClick={handleClick}
      >
        {children}
      </a>
      <ConfirmDialog
        open={confirm}
        dialogTitle={title}
        dialogContent={description}
        confirmBtnText={confirmLabel}
        cancelBtnText={cancelLabel}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
};

ConfirmLink.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
  isWarning: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
};

ConfirmLink.defaultProps = {
  href: `#`,
  isWarning: false,
};

ConfirmLink.displayName = `ConfirmLink`;

export default ConfirmLink;
